import { render, staticRenderFns } from "./AscAlertItem.vue?vue&type=template&id=52e0519e&"
import script from "./AscAlertItem.vue?vue&type=script&lang=js&"
export * from "./AscAlertItem.vue?vue&type=script&lang=js&"
import style0 from "./AscAlertItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports